<template>
  <div>
    <div class="" v-if="!inLoad || !showAlert">
      <div class="alertWrap" v-if="showAlert">
        <div class="alert">
          <h2 class="modalTitle tit1 text-center mb-0">{{ lang[currnetLang][1] }}</h2>
          <label class="my-2" for style="font-size:14px">{{ lang[currnetLang][2] }}</label>
          <div class="wallet_name m-0 noIcon">
            <input class v-model="user_name" type="text" :placeholder="lang[currnetLang][5]" />
            <div class="icon">
              <div class="icon_bg">
                <i class="fa fas fa-user"></i>
              </div>
            </div>
          </div>
          <p class="text-danger text-left mt-2" style="font-size:14px">-{{ lang[currnetLang][3] }}!</p>
          <button class="btn" :disabled="disabledBtn" @click="sendOrder">{{ lang[currnetLang][4] }}</button>
        </div>
      </div>
      <div class="flex-column justify-content-start align-items-center" v-if="timeMsg == ''">
      </div>
      <div v-else class="timeMsg">
        <h4 class="tit1" style="color:#007bff !important">{{ timeMsg }}</h4>
      </div>
    </div>
    <div v-else style="min-height:100vh" class="d-flex justify-content-center align-items-center">
      <div class="loadWrap">
        订单号: {{ $route.query.transaction_id }}
        <div v-if="order.real_price" class="amount mt-3">￥{{ order.real_price }}</div>
         <p class="text-dark mt-3">正为您寻找最佳充值渠道<br >等候时间约为20到100秒，请勿离开或是关闭画面，感谢您的耐心等候</p>
        <div class="progress-bar progress-bar-striped progress-bar-animated " role="progressbar" aria-valuenow="45"
          aria-valuemin="0" aria-valuemax="100" style="width: 80%;height:20px">
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.amount {
  color: red;
  font-size:40px;
  font-weight: bold;
}
.loadWrap {
  width: 455px;
  padding: 20px;
  background-color: #fff;
  border-radius: 10px
}
.m-message-container.is-top-center {
  z-index: 9999 !important;
}

.m-message {
  z-index: 9999 !important;
}

.m-message-container {
  z-index: 9999 !important;
}

.allWrap {
  // background-color: #fff;
}

.alertWrap {
  position: fixed;
  z-index: 90;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, .5);
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  .alert {
    width: 345px;
    box-shadow: 0 0 3px 3px rgba(0, 0, 0, .6);
    height: 345px;
    background-color: white;
    border-radius: 5px;
  }
}
</style>
<script>
import axios from "axios";
export default {
  data() {
    return {
      inLoad: false,
      order: "",
      timeout: "",
      timeMsg: "",
      showAlert: true,
      user_name: "",
      currnetLang: "cn",
      lang: {
        cn: {
          // 1:'银联网关支付',
          // 2:'您的银行卡的户主姓名(不能填错)',
          1: '实名验证',
          2: '输入卡主户名',
          3: '必须输入您转账银行卡户主姓名 ,非姓名无法到账,恕不负责!',
          4: '确认',
          5: '输入卡主户名'
        },
        ja: {
          1: "銀聯関連の支払い",
          2: "キャッシュカードの所有者名（間違って入力することはできません）",
          3: "送金には銀行カードの所有者の名前を入力する必要があります。名前がないと口座を受け取ることはできません。また、私たちは責任を負いません!",
          4: "確認",
          5: "キャッシュカードの所有者名"
        }
      },
    };
  },
  computed: {
    disabledBtn() {
      return this.$store.state.isLoading
    }
  },
  methods: {
    getOrder() {
      let lang = this.currnetLang;

      axios.get(`${process.env.VUE_APP_DEFAULT_SRC}/aaa/query?transaction_id=${this.$route.query.transaction_id}`, {
        headers: {
          'X-LOCALIZATION': lang 
        }
      })
        .then(res => {
          if (res.data.code == 0) {
            this.order = res.data.data;
            if (res.data.data.user_name && res.data.data.view_url && res.data.data.view_url.indexOf(location.origin) == -1) {
              location.href = res.data.data.view_url
            }
          } else {
            this.$message({ type: 'error', message: res.data.message, duration: -1 })
            this.timeMsg = res.data.message;
            this.showAlert = false;
            clearInterval(this.timeout);
          }
        });
    },
    sendOrder() {
      // this.disabledBtn = true;
      let lang = this.currnetLang;
      if (!this.user_name) return

      let type = {
        '20005': '注文は存在しません',
        '20012': "注文の有効期限が切れました。",
        '20013': "問題がある場合は、ご連絡ください。",
        '20000': "問題が発生しました。ご連絡ください。",
        '20014': "注文は完了しました。",
      }
      this.inLoad = true;
      setInterval(() => {
        if((document.querySelector('.progress-bar').style.width.split('%')[0] * 1) - 0.5 <= 15) return
        document.querySelector('.progress-bar').style.width = (document.querySelector('.progress-bar').style.width.split('%')[0] * 1) - 0.5 + '%'
      }, 500);
      axios
        .post(
          `${process.env.VUE_APP_DEFAULT_SRC}/aaa/send?transaction_id=${this.$route.query.transaction_id}&user_name=${this.user_name}`, {
          transaction_id: this.$route.query.transaction_id,
          user_name: this.user_name
        }, {
          headers: {
            'X-LOCALIZATION': lang
          }
        }
        )
        .then(res => {
          this.inLoad = false;
          if (res.data.code == 0) {
            window.location.href = res.data.data.view_url;
            this.order = res.data.data;
          } else {
            this.showAlert = false
            if (lang == 'ja') {
              this.timeMsg = type[code];
            } else {
              this.timeMsg = res.data.message;
            }
            clearInterval(this.timeout);
            this.$message({ type: 'error', message: res.data.message, duration: -1 })
          }
        }).catch(() => {
          // this.disabledBtn = false;
          this.inLoad = false;
        });
    }
  },
  created() {
    if (
      navigator.language.toLowerCase().indexOf('ja') != -1 ||
      navigator.language.toLowerCase().indexOf('jp') != -1
    ) {
      this.currnetLang = 'ja'
    }
    this.getOrder();
    // this.timeout = setInterval(() => this.getOrder(), 10000);
  }
};
</script>
<style lang="scss" scoped>
input {
  background-color: rgb(238, 238, 238);
  height: 40px;
  border: none;
  color: black
}

button {
  background-color: #007bff;
  color: white
}

.modalTitle {
  color: black !important
}

.account_name {
  word-break: break-all;
}

.timeMsg {
  height: 90vh;
  display: flex;
  align-items: center;

  h4 {
    text-align: center;
  }
}

.alertWrap {
  .alert {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .btn {
      margin-top: auto;
    }
  }
}
</style>

<style lang="scss">
body {
  background-color: #EBEFF0 !important;
}


</style>